import React, { FC, PropsWithChildren } from 'react';
import { BackofficeWidgetCard } from './BackofficeWidgetCard';
import { BackofficeWidgetCardHeading } from './BackofficeWidgetCardHeading';
import { MovingGradient } from '../../../../components/MovingGradient';
import { FlexGrid, FlexGridColumn } from '../../../../components/FlexGrid';
import { Button } from '../../../../components/Button';
import { PaddingBox } from '../../../../components/PaddingBox';

export const BackofficeWidgetPlaceholder: FC<PropsWithChildren> = () => {
	return (
		<BackofficeWidgetCard>
			<BackofficeWidgetCardHeading>
				<MovingGradient
					borderRadius='4px'
					height='14px'
					width='40%'
				/>
			</BackofficeWidgetCardHeading>
			<FlexGrid>
				<FlexGridColumn grow>
					<MovingGradient
						borderRadius='4px'
						height='14px'
						width='40%'
					/>
					<PaddingBox topTiny>
						<MovingGradient
							borderRadius='4px'
							height='12px'
							width='50%'
						/>
					</PaddingBox>
				</FlexGridColumn>
				<FlexGridColumn>
					<Button
						size='small'
						disabled
						primary
					></Button>
				</FlexGridColumn>
			</FlexGrid>
		</BackofficeWidgetCard>
	);
};
